import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ScenarioSectionProp } from ".";
import UTIL from "../../../../../utils/utils";



const EstimatedIndirectImpactSection = (props: ScenarioSectionProp) => {


    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbReputationRisk")}
                    >
                        <span>
                            {UTIL.getRiskLevelName(data.reputation_risk)}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbSolvencyRisk")}
                    >
                        <span>
                            {UTIL.getRiskLevelName(data.solvency_risk)}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbRegulatoryRisk")}
                    >
                        <span>
                            {UTIL.getRiskLevelName(data.regulatory_risk)}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbSecuritiesRisk")}
                    >
                        <span>
                            {UTIL.getRiskLevelName(data.liquidity_risk)}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbLossCustomer")}
                    >
                        <span>
                            {UTIL.getRiskLevelName(data.loss_of_customer)}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbLossStaff")}
                    >
                        <span>
                            {UTIL.getRiskLevelName(data.loss_of_staff)}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbComments")}
                    >
                        <span>
                            {data.indirect_impact_comments}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default EstimatedIndirectImpactSection;